import React, { Component } from "react";

import { Access } from "common";
import { Page, Breadcrumbs, Navigation } from "components";

class Main extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Configurações", to: "" },
    ],
    navigation: [
      {
        name: "Mensagens",
        to: "/configs/messages",
        hidden: !Access.hasPermissions("edit-messages"),
      },
      {
        name: "Usuários",
        to: "/configs/users",
        hidden: !Access.hasPermissions("edit-users"),
      },
      {
        name: "Grupos de Acesso",
        to: "/configs/groups",
        hidden: !Access.hasPermissions("edit-access-groups"),
      },
      {
        name: "Permissões",
        to: "/configs/roles",
        hidden: !Access.hasPermissions("edit-permissions"),
      },
      {
        name: "Variáveis",
        to: "/configs/settings",
        hidden: !Access.hasPermissions("edit-variables"),
      },
      {
        name: "Log",
        to: "/configs/log",
        hidden: !Access.hasPermissions("edit-log"),
      },
      {
        name: "Incidentes",
        to: "/configs/incidents",
        hidden: !Access.hasPermissions("edit-incidents"),
      },
    ],
  };

  render() {
    const { breadcrumbs, navigation } = this.state;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Navigation items={navigation} />
      </Page>
    );
  }
}

export default Main;
